<template>
  <el-button
    class="y-button"
    v-bind="$attrs"
    :disabled="disabled"
    @click="handleClick"
  >
    <img src="../../../assets/icons/google-icon.png" class="google-icon" />
    {{ t("shared.auth.loginByGoogle") }}
  </el-button>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["click"]);

const handleClick = () => {
  if (props.disabled) {
    return;
  }
  emit("click");
};

defineOptions({
  name: "YGoogleButton"
});
</script>

<style lang="scss" scoped>
.y-button {
  --el-border-radius-base: 0;
  --y-button-space: 20px;
  --y-button-border-color: #eeeeee;
  width: 100%;
  height: 48px;
  margin-left: 0;
  border: 1px solid var(--y-button-border-color);
  font-family: var(--y-button-font, var(--y-medium-font));
  font-weight: var(--y-button-weight);
  font-size: 16px;
  background: #ffffff;
  color: #696969;

  .google-icon {
    width: 18px;
    height: 18px;
    margin-right: 13px;
  }
  &.is-plain {
    --y-button-border-color: var(--y-border-color);
    --el-button-bg-color: transparent;
    --el-button-hover-bg-color: rgba(255, 255, 255, 0.1);
    color: #696969;
  }
}
</style>
